// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asc-components-successful[data-v-bea6a000]{width:100%}.asc-components-successful h1[data-v-bea6a000]{font-weight:700;font-size:16px;line-height:16px;color:#233238}.asc-components-successful p[data-v-bea6a000]{font-size:15px;line-height:19px;color:#233238}", ""]);
// Exports
module.exports = exports;
